import React from "react";
import classNames from "classnames";

import "./styles.styl";
import { FormattedMessage } from "react-intl";

export default function DepositOverview(props) {
  const { className, customer, ...rest } = props;
  const outstanding_list = customer.list_outstanding_deposit_events;
  const non_invoiced_incoming = customer.list_non_invoiced_incoming;
  const has_non_invoiced_incoming = non_invoiced_incoming.length ? true : false;
  const outstanding_list_credit = non_invoiced_incoming.reduce(
    (accumulator, deposit) => {
      return (
        accumulator +
        parseInt(deposit.incoming) * parseFloat(deposit.deposit__price)
      );
    },
    0,
  );
  // TODO: use currencyFormat here instead of parseFloat
  return (
    <div
      className={classNames("deposit", className)}
      {...rest}
      style={{ padding: "1rem" }}
    >
      <h2>
        <FormattedMessage id="overviewDeposit" />
      </h2>
      {outstanding_list.length > 0 ? (
        <>
          <div>
            <p className="letted_md_paragraph">
              <FormattedMessage id="returnedAndCredited" />
            </p>
            {has_non_invoiced_incoming && (
              <div>
                {non_invoiced_incoming.map((deposit) => (
                  <div className="deposits">
                    <div className="deposits_fields_name">
                      {deposit.deposit__name}
                    </div>
                    <div className="deposit_amount_and_price">
                      <div className="deposits_fields">{deposit.incoming}</div>
                      <div className="deposits_fields">
                        {parseFloat(deposit.deposit__price).toFixed(2)}€
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="no-deposit">
          <p>
            <FormattedMessage id="noCurrentReturns" />
          </p>
        </div>
      )}
      <div>
        <p></p>
        <hr></hr>
        <div className="deposits">
          <div className="total_label deposits_fields_name">
            <FormattedMessage id="total" />
          </div>
          :<div className="deposits_fields">{outstanding_list_credit}€</div>
        </div>
      </div>
    </div>
  );
}
